module.exports = __webpack_public_path__ + "images/home/orientation/highlights.2bc06dddced721a031de.svg";


//////////////////
// WEBPACK FOOTER
// ./resources/images/home/orientation/highlights.svg
// module id = j6dR
// module chunks = 13